import React from 'react';
import { ButtonProps, Div, DivProps } from '@kizi/core-components';

import { SubmitCurrentFormButton } from './Button/SubmitCurrentFormButton';
import { SecureConnection } from '../SecureConnection';

export interface SubmitCurrentFormBtnWrapperProps extends DivProps {
  text: string;
  submitCurrentFormButtonProps: ButtonProps;
  secureConnectionProps: DivProps;
}

export const SubmitCurrentFormBtnWrapper = ({
  text,
  submitCurrentFormButtonProps,
  secureConnectionProps,
  ...rest
}: SubmitCurrentFormBtnWrapperProps) => (
  <Div
    mt={6}
    display={['block', null, 'flex']}
    justifyContent="space-between"
    {...rest}
  >
    <SubmitCurrentFormButton
      variant="primary"
      {...submitCurrentFormButtonProps}
    >
      {text}
    </SubmitCurrentFormButton>

    <SecureConnection
      display={['flex', 'flex', 'block']}
      justifyContent={['flex-end', null, 'unset']}
      mt={[6, 0, 0]}
      {...secureConnectionProps}
    />
  </Div>
);
